// user_config.js

export const passwordMinLength = 6;



// WEBPACK FOOTER //
// ./src/utils/user_config.js